// extracted by mini-css-extract-plugin
export var container = "_cn-0";
export var icon = "_cn-1";
export var text = "_cn-2";